import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Tab, Tabs } from 'react-bootstrap';
import TaskKnowledgeCase from './TaskKnowledgeCase';
import TaskHistoryCase from './TaskHistoryCase';
import { apiService } from '../../../../services/apiService';
import AssignmentsCase from './AssignmentsCase';
function CaseDetails({expanded}) {
    const [activeTab, setActiveTab] = useState("overview");
    const caseIds = sessionStorage.getItem('onBoardCaseID');
    const [loading, setLoading] = useState(true);
    const [dataCase, setDataCase] = useState({});

    const fetchData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`/case/details/${caseIds}`);
            if (response.success && response.success === true) {
                setDataCase(response.data);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }

        } catch (error) {
        console.error("Error fetching onboarding data:", error);
        } finally {
        setLoading(false);
        }
    }, [caseIds]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
  return (
    <Grid size={{xs:12}} container flexDirection="column" justifyContent="start" className={`tab_controllers ${ expanded && "control_splits"}`}>
        <Tabs
            activeKey={activeTab}
            onSelect={(key) => setActiveTab(key)}
            defaultActiveKey="overview"
            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
        >
            <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                {loading ? 
                    <div className='d-flex justify-content-center align-items-start w-100'>
                        <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :
                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="i94viewvalidate">
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Case Number<small>*</small></span>
                            <p>{dataCase.format_id || "N/A"}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Jobseeker<small>*</small></span>
                            <p>{dataCase.jobseeker.name || "N/A"}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Title<small>*</small></span>
                            <p>{dataCase && dataCase.type === "onboarding" ? dataCase.jobseeker.name : dataCase.stage}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Case Status<small>*</small></span>
                            <p>{dataCase.case_status || "N/A"}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Case Open Date<small>*</small></span>
                            <p>{dataCase.created_at || "N/A"}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Case Opened by<small>*</small></span>
                            <p>{dataCase.requested_by || "N/A"}</p>
                        </Grid>
                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                            <span>Case Closed<small>*</small></span>
                            <p>{dataCase.closed_date || "N/A"}</p>
                        </Grid>
                    </Grid>
                }
            </Tab>
            <Tab eventKey="assignments" title="Assignments">
                {activeTab === "assignments" && <AssignmentsCase />}
            </Tab>
            <Tab eventKey="knowledge" title="Knowledge">
                {activeTab === "knowledge" && <TaskKnowledgeCase />}
            </Tab>
            <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                {activeTab === "history" && <TaskHistoryCase />}
            </Tab>
        </Tabs>
    </Grid>
  )
}

export default CaseDetails
